import get from 'lodash/get'
import uniq from 'lodash/uniq'

import {reducer} from '../helpers'
import {CheckoutStepSlugs, CheckoutFunnels} from '../../store/enum'

import {
  ACCEPT_CHECKOUT_PROMPT,
  COMPLETE_CHECKOUT_FAILURE,
  GET_FIT_GUARANTEE_FAILURE,
  GET_FIT_GUARANTEE_SUCCESS,
  GET_ORDER_SUMMARY_FAILURE,
  GET_ORDER_SUMMARY_PENDING,
  GET_ORDER_SUMMARY_SUCCESS,
  GET_SHIPPING_ADDRESS_FAILURE,
  GET_SHIPPING_ADDRESS_PENDING,
  GET_SHIPPING_ADDRESS_SUCCESS,
  HIDE_SUMMARY_LOADER,
  NAVIGATE_TO_CHECKOUT_STEP,
  SAVE_BILLING_ADDRESS_SUCCESS,
  SAVE_BILLING_ADDRESS_FAILURE,
  SAVE_BILLING_ADDRESS_PENDING,
  SAVE_PARTNER_INFO_FAILURE,
  SAVE_SHIPPING_ADDRESS_FAILURE,
  SAVE_SHIPPING_ADDRESS_PENDING,
  SAVE_SHIPPING_ADDRESS_SUCCESS,
  SET_CHECKOUT_STEPS,
  RESET_CHECKOUT_STEP,
  START_CHECKOUT,
  SHOW_SUMMARY_LOADER,
  TOGGLE_ACCOUNT_BALANCE_USE,
  UPDATE_CHECKOUT_VERSIONS,
  VALIDATE_PRECHECKOUT_FAILURE,
  VALIDATE_PRECHECKOUT_PENDING,
  VALIDATE_PRECHECKOUT_SUCCESS,
} from '../../actions/checkout'
import {FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS} from '../../actions/worldpay'

export const initialState = {
  billingAddress: {
    isPending: false,
    version: null,
    zip: '',
  },
  steps: CheckoutFunnels.default,
  currentStep: CheckoutStepSlugs.shipping,
  errors: [],
  prompts: [],
  isNavigatingForward: true,
  isProcessingCheckout: false,
  isUsingAccountBalance: true,
  orderSummary: {
    accountBalance: 0,
    accountBalanceToApply: 0,
    eventLooks: [],
    subtotal: 0,
    insurance: {
      total: 0,
      quantity: 0,
    },
    isPending: false,
    shipping: {
      total: 0,
      quantity: 0,
      isRushed: false,
    },
    discount: {
      total: 0,
      code: '',
      error: '',
    },
    tax: 0,
    total: 0,
  },
  precheckoutValidation: {
    isOrderValidated: false,
    isPending: false,
    isValidOrder: false,
  },
  shippingAddress: {
    address1: '',
    address2: '',
    city: '',
    firstName: '',
    isPending: false,
    lastName: '',
    phone: '',
    state: '',
    toBusinessAddress: false,
    version: null,
    zip: '',
  },
  shouldShowSummaryLoader: false,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case RESET_CHECKOUT_STEP:
      return {currentStep: CheckoutStepSlugs.shipping}
    case START_CHECKOUT:
      return {currentStep: CheckoutStepSlugs.shipping}
    case SET_CHECKOUT_STEPS:
      return {steps: action.payload.steps}
    case SAVE_PARTNER_INFO_FAILURE:
      return {errors: action.payload ? [action.payload] : []}
    case UPDATE_CHECKOUT_VERSIONS:
      return {
        billingAddress: {
          ...state.billingAddress,
          version: action.payload.billingVersion,
        },
        shippingAddress: {
          ...state.shippingAddress,
          version: action.payload.shippingVersion,
        },
      }
    case VALIDATE_PRECHECKOUT_PENDING:
      return {
        precheckoutValidation: {
          ...state.precheckoutValidation,
          isPending: true,
        },
      }
    case VALIDATE_PRECHECKOUT_FAILURE:
      return {
        errors: action.payload ? [action.payload] : [],
        precheckoutValidation: {
          isOrderValidated: true,
          isPending: false,
          isValidOrder: false,
        },
      }
    case VALIDATE_PRECHECKOUT_SUCCESS:
      return {
        errors: get(action, 'payload.errors', []),
        precheckoutValidation: {
          isOrderValidated: true,
          isPending: false,
          isValidOrder: get(action, 'payload.isValidOrder', false),
        },
      }
    case GET_FIT_GUARANTEE_FAILURE: {
      return {
        prompts: [],
      }
    }
    case GET_FIT_GUARANTEE_SUCCESS: {
      const fitPrompt = {type: 'FIT_GUARANTEE'}
      if (state.errors.length === 0) {
        return {
          prompts: uniq([
            ...state.prompts,
            ...(!action.payload.isFitGuaranteed ? [fitPrompt] : []),
          ]),
        }
      }
      return {}
    }
    case GET_ORDER_SUMMARY_PENDING:
      return {
        orderSummary: {
          ...state.orderSummary,
          isPending: true,
        },
      }
    case GET_ORDER_SUMMARY_SUCCESS:
      return {
        orderSummary: {
          isPending: false,
          ...action.payload,
        },
      }
    case GET_ORDER_SUMMARY_FAILURE:
      return {
        orderSummary: {
          isPending: false,
        },
        errors: action.payload ? [action.payload] : [],
      }
    case GET_SHIPPING_ADDRESS_PENDING:
      return {
        shippingAddress: {
          ...state.shippingAddress,
          isPending: true,
        },
      }
    case GET_SHIPPING_ADDRESS_SUCCESS:
      return {
        shippingAddress: {
          ...state.shippingAddress,
          ...action.payload,
          isPending: false,
        },
      }
    case GET_SHIPPING_ADDRESS_FAILURE:
      return {
        shippingAddress: {
          ...state.shippingAddress,
          isPending: false,
        },
        errors: action.payload ? [action.payload] : [],
      }
    case COMPLETE_CHECKOUT_FAILURE:
      return {
        errors: action.payload ? [action.payload] : [],
      }
    case SAVE_SHIPPING_ADDRESS_SUCCESS:
      return {
        isNavigatingForward: true,
        shippingAddress: {
          ...state.shippingAddress,
          ...action.payload,
          isPending: false,
        },
      }
    case SAVE_SHIPPING_ADDRESS_FAILURE:
      return {
        shippingAddress: {
          ...state.shippingAddress,
          isPending: false,
        },
        errors: action.payload ? [action.payload] : [],
      }
    case SAVE_SHIPPING_ADDRESS_PENDING:
      return {
        shippingAddress: {
          ...state.shippingAddress,
          isPending: true,
        },
      }
    case SAVE_BILLING_ADDRESS_SUCCESS:
      return {
        billingAddress: {
          ...state.billingAddress,
          ...action.payload,
          isPending: false,
        },
      }
    case SAVE_BILLING_ADDRESS_PENDING:
      return {
        billingAddress: {
          ...state.billingAddress,
          isPending: true,
        },
      }
    case SAVE_BILLING_ADDRESS_FAILURE:
      return {
        billingAddress: {
          ...state.billingAddress,
          isPending: false,
        },
        errors: action.payload ? [action.payload] : [],
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS:
      return {
        isNavigatingForward: true,
      }
    case SHOW_SUMMARY_LOADER:
      return {
        shouldShowSummaryLoader: true,
      }
    case HIDE_SUMMARY_LOADER:
      return {
        shouldShowSummaryLoader: false,
      }
    case NAVIGATE_TO_CHECKOUT_STEP:
      return {
        currentStep: action.payload.currentStep,
        isNavigatingForward: action.payload.direction === 'forward',
      }
    case ACCEPT_CHECKOUT_PROMPT:
      return {
        prompts: state.prompts.filter(({type}) => type !== action.payload.type),
      }
    case TOGGLE_ACCOUNT_BALANCE_USE:
      return {isUsingAccountBalance: !state.isUsingAccountBalance}
    default:
      return null
  }
})
